import React, { PropsWithChildren, useState } from 'react';
import { vibrate } from '../../Utils/Helpers';
import ButtonBase from './ButtonBase';

interface ButtonPrimaryProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  className?: string;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset';
  withLoading?: boolean;
}

const ButtonPrimary = ({
  children,
  onClick = () => {},
  disabled,
  rounded = false,
  className,
  outline = false,
  type = 'button',
  withLoading = false
}: PropsWithChildren<ButtonPrimaryProps>) => {

  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (withLoading) {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
      }, 5000);
    }

    onClick();
    vibrate();
  };

  return (
    <ButtonBase
      type={type}
      onClick={handleClick}
      disabled={disabled || loading}
      rounded={rounded}
      className={`
        text-base
        ${className} text-custom-primary ring-custom-primary hover:brightness-[110%] ring-2
        ${outline ? 'text-custom-primary' : 'text-white bg-custom-primary'}
      `}
    >
      {loading ? (
        <span className="animate-pulse">Carregando...</span>
      ) : (
        children
      )}
    </ButtonBase>
  );
};

export default ButtonPrimary;